import React, { useState } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import * as Icon from 'react-feather';
import { useDispatch } from 'react-redux';
import { setScreenType, useCallId, useCallType } from '../../../store/slices/dialSlice';
import { dtmfPress } from '../../../store/slices/callingSlice';

const DtmfScreen = () => {
  const callId = useCallId();
  const callType = useCallType();

  const dispatch = useDispatch();
  const [dtmfNum, setDtmfNum] = useState('');

  const onNumberChange = (val) => {
    setDtmfNum(dtmfNum + val);
    onDtmfPress(val);
  };

  const onDtmfPress = async (val) => {
    try {
      const payload = {
        uuid: callId,
        dtmf_number: val,
        calltype: callType
      };
      const response = await dispatch(dtmfPress(payload)).unwrap();
      console.log('response', response);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className="input-container">
      <div className="input-wrapper">
        <Input
          type="text"
          value={dtmfNum}
          onChange={(e) => {
            const value = e.target.value;
            const val = value.replace(/[^0-9*#]+/g, '');
            setDtmfNum(val);
            if (val?.length > dtmfNum?.length) {
              onDtmfPress(val.charAt(val?.length - 1));
            }
          }}
          className="dail-input"
          pattern="[0-9]+"
        />
        <div
          className="remove-icon-wrapper"
          onClick={() => {
            const num = dtmfNum.slice(0, -1) || '';
            setDtmfNum(num);
          }}>
          <Icon.Delete className="remove-icon" />
        </div>
      </div>

      <Row className="button-grid pb-3">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'].map((val, idx) => (
          <Col key={idx} className="button-col p-0">
            <div className="dial-button" onClick={() => onNumberChange(val)}>
              <span>{val}</span>
            </div>
          </Col>
        ))}
        <div></div>
        <div className="call-button-wrapper">
          <Button
            className="back-button"
            onClick={() => {
              dispatch(setScreenType('LIVE_CALL'));
              setDtmfNum('');
            }}>
            <Icon.ArrowLeft className="back-icon text-primary" />
          </Button>
        </div>
      </Row>
    </div>
  );
};

DtmfScreen.propTypes = {};

export default DtmfScreen;
